import React from 'react';

const WelcomeLoader = () => (
	<div className="com-loader welcome">
		<div className="dx-col">
			<div className="loader-content">
				<img src="/media/icons/com-loader-welcome.svg" className="com-loader-welcome-icon" alt="Welcome" />
				<div className="loader-text">
					Welcome!
				</div>
			</div>
		</div>
	</div>
)

export default WelcomeLoader;



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/Loader/WelcomeLoader.js